import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { GlobalConfig } from 'psc-ng-common';
import { FirebaseDatabaseService } from 'psc-ng-firebase';

import { NavMenu } from '../interfaces/nav-menu';

@Injectable({
  providedIn: 'root'
})
export class NavMenuApiService extends FirebaseDatabaseService {
  constructor(public angularFirestore: AngularFirestore) {
    super(angularFirestore, 'appShellMenu', { active: 'title', direction: 'desc' },
      { pageIndex: 1, pageSize: GlobalConfig.DEFAUL_TOTAL_ITEMS_PER_PAGE, length: 0 }, []);
  }
  getNavMenu() {
    const query = this.collection.orderBy('title', 'desc').limit(10);
    return this.getByfilter<NavMenu>(query);
  }
}
